import { duration } from "@mittwald/flow-styles/dist/tokens/ts/variables";
import styled from "styled-components";
import Box from "../../Box";
import imageBoxMixin from "../../../mixins/imageBox";
export const ClickActionOverlayContainer = styled(Box) `
  cursor: pointer;

  transition: opacity ${duration.animation.moderate}ms;

  & {
    opacity: 0;
  }

  &:hover {
    opacity: 1;
  }

  ${imageBoxMixin};
`;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQ2xpY2tBY3Rpb25PdmVybGF5Q29udGFpbmVyLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvSW1hZ2VCb3gvc3R5bGVkL0NsaWNrQWN0aW9uT3ZlcmxheUNvbnRhaW5lci50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxPQUFPLEVBQUUsUUFBUSxFQUFFLE1BQU0sZ0RBQWdELENBQUM7QUFDMUUsT0FBTyxNQUFNLE1BQU0sbUJBQW1CLENBQUM7QUFDdkMsT0FBTyxHQUFHLE1BQU0sV0FBVyxDQUFDO0FBQzVCLE9BQU8sYUFBYSxNQUFNLDBCQUEwQixDQUFDO0FBRXJELE1BQU0sQ0FBQyxNQUFNLDJCQUEyQixHQUFHLE1BQU0sQ0FBQyxHQUFHLENBQUMsQ0FBQTs7O3dCQUc5QixRQUFRLENBQUMsU0FBUyxDQUFDLFFBQVE7Ozs7Ozs7Ozs7SUFVL0MsYUFBYTtDQUNoQixDQUFDIn0=